import { getList, clientLock, clientActivate, getSingleClient, addNewClient, editClient } from '../../repository/clients/index';

const state = {
  clientsList: null,
  clientsListPages: null,
  dialogVisibility: false,
  singleClient: null,
  postsPerPage: 10,
  totalPages: null,
  query: null,
  currentPage: 1,
};

const getters = {
  clientsList: store => store.clientsList,
  clientsListPages: store => store.clientsListPages,
  dialogVisibility: store => store.dialogVisibility,
  singleClient: store => store.singleClient,
  query: store => store.query,
  postsPerPage: store => store.postsPerPage,
  totalPages: store => store.totalPages,
  currentPage: store => store.currentPage,
};

const mutations = {
  SET_CLIENTS_LIST(state, clientsList) {
    state.clientsList = clientsList;
  },
  SET_TOTAL_PAGES(state, total) {
    state.totalPages = total;
  },
  SET_DIALOG_VISBILITY(state, type) {
    state.dialogVisibility = type;
  },
  SET_ACTIVE_LIST_ITEM(state, id) {
    state.activeListItem = id;
  },
  SET_SINGLE_CLIENT(state, client) {
    state.singleClient = client;
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
};

const actions = {
  setCurrentPage({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  setQuery({ commit }, query) {
    commit('SET_QUERY', query);
  },
  async getClientsList({ commit, state }) {
    const { currentPage } = state;
    const defaultSort = {
      sort_by: 'name',
      sort_dir: 'asc',
    };
    const query = {
      ...defaultSort,
      ...state.query,
    };
    const params = {
      page: currentPage,
      length: state.postsPerPage,
      ...query,
    };
    commit('SET_CLIENTS_LIST', null);
    let getClients = await getList(params);
    getClients = getClients.data.data;
    commit('SET_CLIENTS_LIST', getClients.items);
    commit('SET_TOTAL_PAGES', getClients.totalPages);
  },
  async lockClient({ dispatch }, id) {
    await clientLock(id);
    dispatch('getClientsList');
  },
  async activateClient({ dispatch }, id) {
    await clientActivate(id);
    dispatch('getClientsList');
  },
  setDialogVisbility({ commit }, type) {
    commit('SET_DIALOG_VISBILITY', type);
  },
  setActiveListItem({ commit }, id) {
    commit('SET_ACTIVE_LIST_ITEM', id);
  },
  async getSingleClient({ commit }, id) {
    commit('SET_SINGLE_CLIENT', null);
    const getClient = await getSingleClient(id);
    const { client } = getClient.data.data;
    commit('SET_SINGLE_CLIENT', client);
  },
  async storeNewClient({ dispatch }, data) {
    await addNewClient(data);
    await dispatch('getClientsList');
  },
  async clientUpdate({ dispatch }, userData) {
    await editClient(userData.id, userData.data);
    await dispatch('getSingleClient', userData.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
